import { createContext, useState, useEffect, useCallback, useMemo } from "react";
import api from "./httpClient";

export const UserContext = createContext(null);

export const UserProvider = ({children}) => {
  /* PREVIOUS VERSION FROM SOME CLAUDE INDUCED MISHAPS 
  const [user, setUser] = useState(() => {
    // Initialize from localStorage on app start
    try {
      const savedToken = localStorage.getItem('jwt');
      return savedToken ? { jwt: savedToken } : null;
    } catch (error) {
      console.error('Error getting token from localStorage:', error);
      return null;
    }
  });
  */
  
  /* PREVIOUS VERSION FROM SOME CLAUDE INDUCED MISHAPS 
  // Save to localStorage when user changes
  useEffect(() => {
    if (user?.jwt) {
      localStorage.setItem('jwt', user.jwt);
    } else {
      localStorage.removeItem('jwt');
    }
  }, [user]);

  const login = (tokenOrUserData) => {
    if (typeof tokenOrUserData === 'string') {
      setUser({ jwt: tokenOrUserData });
    } else {
      setUser(tokenOrUserData);
    }
  };

  const isTokenExpired = useCallback((token) => {
    console.log('isTokenExpired has been hit');
    const tokenToCheck = token || user?.jwt;
    if (!tokenToCheck) return true;
    try {
      const payload = JSON.parse(atob(tokenToCheck.split('.')[1]));
      return payload.exp * 1000 < Date.now();
    } catch {
      return true; // Consider expired
    }
  }, [user]);

  */  

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    api.get('/auth/me')
      .then(res => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, [])
  
  const login = (userData) => setUser(userData);

  const logout = async () => {
    await api.post('logout');
    setUser(null);
  }

  const value = {
    user,
    login,
    logout,
    loading,
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  )
}

 